module.exports = __webpack_public_path__ + "img/groups-icon-active.1fb8898b.svg";